// MapLibre GL JS map initialization

let map = null;
let marker = null;

export function initMap(containerId = 'map') {
  const container = document.getElementById(containerId);
  if (!container || typeof maplibregl === 'undefined') return null;

  map = new maplibregl.Map({
    container: containerId,
    style: 'https://tiles.openfreemap.org/styles/liberty',
    center: [-73.98, 40.75], // NYC center
    zoom: 11,
    attributionControl: true,
  });

  map.addControl(new maplibregl.NavigationControl(), 'top-right');

  return map;
}

export function flyTo(lng, lat, zoom = 16) {
  if (!map) return;
  map.flyTo({ center: [lng, lat], zoom, duration: 1500 });
}

export function setMarker(lng, lat, popupHtml) {
  if (!map) return;

  // Remove existing marker
  if (marker) marker.remove();

  marker = new maplibregl.Marker({ color: '#1a56db' })
    .setLngLat([lng, lat])
    .addTo(map);

  if (popupHtml) {
    marker.setPopup(
      new maplibregl.Popup({ offset: 25, closeButton: false })
        .setHTML(popupHtml)
    ).togglePopup();
  }
}

export function getMap() {
  return map;
}
